import { Menu, Layout } from "antd";
import React, { useEffect } from 'react';
import './SearchInvoice.css'
import bodyData from "../../../data/SearchInvoice/body";
import { useNavigate } from "react-router-dom";
import useQuery from "../../../helper/queryString";
const getBody = (key: string) => {
    return bodyData.ComponentOfMenu.find((value) => value.key === key)?.node
        ?? bodyData.ComponentOfMenu[0].node;
}
let initPath = window.location.pathname
if (initPath === '/') initPath = bodyData.ComponentOfMenu[0].key;
else initPath = initPath.startsWith('/') ? initPath.substring(1) : initPath;
const SearchInvoice: React.FC = () => {
    const navigate = useNavigate();
    const query = useQuery();
    const [path, setPath] = React.useState(initPath ?? "single/invoice");

    useEffect(() => {
        let pathTemp = path;
        let taxCode = query.get("masothue");
        let securityCode = query.get("sobaomat");

        if (!taxCode || !securityCode || pathTemp != initPath) {
            navigate(pathTemp);
            return;
        }
        taxCode = encodeURIComponent(taxCode);
        securityCode = encodeURIComponent(securityCode);
        pathTemp = `${pathTemp}?masothue=${taxCode}&sobaomat=${securityCode}`
        navigate(pathTemp);
    }, [path])
    return (
        <Layout className="content">
            <Menu
                mode="horizontal"
                className="search-invoice-menu"
                items={bodyData.MenuItems}
                selectedKeys={[path]}
                onClick={(menuInfo) => {
                    const uri = menuInfo.keyPath.filter((value) => value !== "rc-menu-more").reverse().join('/')
                    setPath(`${uri}`);
                }}
            />
            {getBody(path)}
        </Layout>
    )
}
export default SearchInvoice;